import React from "react";
import styled from "@emotion/styled";

const PointsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "Gilroy";
  font-weight: bold;
  font-size: 18px;
  padding: 16px 16px;
  > svg {
    cursor: pointer;
  }
`;

const Numbers = styled.div`
  display: flex;
  font-size: 30px;
  align-items: center;

  svg {
    margin-right: 10px;
  }
  div {
    margin: 5px 0;
  }
`;

const PointsIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.06863" cy="9.06863" r="9.06863" fill="white" />
      <path
        d="M8.76831 12.1641H6.95033V5.43276H8.71163C9.58938 5.43276 10.2404 5.6115 10.6648 5.96899C11.1647 6.39043 11.4146 6.97607 11.4146 7.72594C11.4146 8.54264 11.1487 9.15154 10.6168 9.55263C10.2535 9.82293 9.73179 9.95808 9.05169 9.95808H8.76831V12.1641ZM8.76831 8.44528L8.85114 8.44964C9.07203 8.44964 9.24787 8.38279 9.37866 8.24909C9.50945 8.11249 9.57485 7.92648 9.57485 7.69106C9.57485 7.45854 9.5109 7.26962 9.38302 7.1243C9.25514 6.97607 9.09238 6.90196 8.89474 6.90196H8.76831V8.44528Z"
        fill="black"
      />
    </svg>
  );
};

const RefreshIcon = props => {
  return (
    <svg
      width="29"
      height="26"
      viewBox="0 0 29 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.3125 0.416504C9.51079 0.416504 3.973 5.77667 3.65521 12.4998H0L5.48221 19.6495L10.875 12.4998H7.28021C7.59438 7.78492 11.519 4.0415 16.3125 4.0415C21.3102 4.0415 25.375 8.10634 25.375 13.104C25.375 18.1017 21.3102 22.1665 16.3125 22.1665C13.4355 22.1665 10.8726 20.8144 9.21233 18.7179L6.98054 21.6771C9.29933 24.2001 12.6162 25.7915 16.3125 25.7915C23.3184 25.7915 29 20.1099 29 13.104C29 6.09809 23.3184 0.416504 16.3125 0.416504Z"
        fill="white"
      />
    </svg>
  );
};

function PlaygroundPoints(props) {
  return (
    <PointsContainer>
      <div>
        <div>Playground Points</div>
        <Numbers>
          <PointsIcon />
          <div>{props.points}</div>
        </Numbers>
      </div>
      <RefreshIcon onClick={() => window.location.reload()} />
    </PointsContainer>
  );
}

PlaygroundPoints.defaultProps = {
  points: "0",
};

export default PlaygroundPoints;
